import { setHeroContext } from '../analytics.ts'
import { browserArmStore, chooseHero, type HeroChoice } from './assign.ts'
import { DEFAULT_HERO } from './tests.ts'
import { type HeroModule, heroVersion, loadHero } from './versions.ts'

export type LiveHero = { choice: HeroChoice } & HeroModule

let current: { v: string | undefined; hero: Promise<LiveHero> } | null = null

/**
 * The hero for `/`, chosen before the first render (route loader), so the visitor never sees one
 * version swap into another. One choice per page load: the loader re-runs on every navigation
 * back to `/`, and a second draw would split one visit across two arms.
 */
export function liveHero(v: string | undefined): Promise<LiveHero> {
  if (current && current.v === v) return current.hero
  const choice = chooseHero(v, { store: browserArmStore, random: Math.random })
  setHeroContext(choice)
  const version = heroVersion(choice.version) ?? heroVersion(DEFAULT_HERO)
  if (!version) throw new Error(`Unknown default hero ${DEFAULT_HERO}`)
  const hero = loadHero(version).then((mod) => ({ choice, Hero: mod.Hero }))
  current = { v, hero }
  return hero
}
